import Sidebar from "./SideBar.vue";
import SidebarLink from "./SidebarLink";
import SidebarSelect from "./SidebarSelect";

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  displaySidebar(value) {
    this.showSidebar = value;
  },
};

const SidebarPlugin = {
  install(Vue) {
    let app = new Vue({
      data: {
        sidebarStore: SidebarStore,
      },
    });

    Vue.prototype.$sidebar = app.sidebarStore;
    Vue.component("side-bar", Sidebar);
    Vue.component("sidebar-link", SidebarLink);
    Vue.component("sidebar-select", SidebarSelect);
  },
};

export default SidebarPlugin;
